
import {Component, type EventEmitter, h, Prop, State, Event, Listen, Watch, Method} from '@stencil/core';
import type { labelProviderInterface } from '../../../LabelProviderInterface';

@Component({
  tag: 'search-filter-product-catalog'
})
export class SearchFilterProductCatalog {
  @State() countrySelected = true;
  @State() toggled = true;
  @Prop() readonly labelProvider?: labelProviderInterface;
  @Prop() readonly countryProcutsCount?: number;
  @Prop() readonly globlProcutsCount?: number;
  @Prop() readonly resetFilter = false;

  @Prop() readonly countryFilterSelected: boolean;

  @Watch('countryFilterSelected')
  updateSelectedValue(value: boolean) {
      this.countrySelected = value;
  }

  @Event({
    eventName: 'search:productCatalogChanged',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    productCatalogChanged: EventEmitter<boolean>;


  @Listen('search:reset', {'target': 'window'})
  handleReset() {
      if(!this.countrySelected)
      {
        this.countrySelected = true;
        this.productCatalogChanged.emit(true);
      }
  }

  @Listen('search:productCatalogWidgetClicked', { target: 'window' })
  handleProductCatalogWidgetClicked() {
      const widgetAlreadyClicked = window.sessionStorage.getItem('productCatalogWidgetClicked');
      if(widgetAlreadyClicked === null){
        this.productCatalogFacetHiglight = true;
        setTimeout(() => {
            this.productCatalogFacetHiglight = false;
        }, 2000);
      }
  }

  @State() productCatalogFacetHiglight = false;

  render() {
      return (
        <div>
          <div class="facet facet-product-catalog" style={this.productCatalogFacetHiglight ? {zIndex: '999'} : null}>
            <a
              class={'facet__header-link'}
              href=""
              onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    this.toggleComponent();
                  }
              }}
            >
              <div
                class={'facet__header'}
                onClick={(e) => {
                    e.preventDefault();
                    this.toggleComponent();
                }}
              >
                <h6 class="facet__title">{this.labelProvider('product.catalog.catalog', 'Catalog')}</h6>
                <div class={`facet__arrow${this.toggled ? '--rotated' : ''}`} />
              </div>
            </a>
            <div
              class={`facet__body-single-option facet__body-single-option${this.handleOpenView()}`}
            >
              <div
                class={`facet__accordion facet__accordion${this.handleOpenView()}`}
              >
                <se-list option="filter" selectedColor="primary" class="single-option-filter-list">
                  <se-list-item
                    item={`${this.labelProvider('product.catalog.filter.country', 'Country')} (${this.countryProcutsCount})`}
                    selected={this.countrySelected}
                    class="single-option-item-label"
                    onClick={() => this.switchCatalog(true)}
                  ></se-list-item>
                  <se-list-item
                    item={`${this.labelProvider('product.catalog.filter.global', 'Global')} (${this.globlProcutsCount})`}
                    selected={!this.countrySelected}
                    class="single-option-item-label"
                    onClick={() => this.switchCatalog(false)}
                  ></se-list-item>
                </se-list>
              </div>
            </div>
          </div>
        </div>
      );
  }

  private handleOpenView() {
      if (this.toggled) {
        return '--open';
      }
      return '--close';
  }

  @Method()
  async toggleComponent(): Promise<void> {
      this.toggled = !this.toggled;
  }

  private switchCatalog(countrySelected:boolean){
      this.productCatalogChanged.emit(countrySelected);
      if(this.countrySelected != countrySelected)
      {
        this.countrySelected = countrySelected;
      }
  }
}
